module.exports = __webpack_public_path__ + "static/media/alert.356fd863.svg";